const booleanData = () => [
    {
        value: true,
        label: {
            fr: 'Oui',
            nl: 'Ya',
            en: 'Yes'
        }
    },
    {
        value: false,
        label: {
            fr: 'Non',
            nl: 'Nee',
            en: 'No'
        }
    }
]

const starsDefaultData = [
    {
            value: 0,
            label: {
            en: "Too low",
            fr: "Trop bas"
        }
    },
    {
            value: 1,
            label: {
            en: "Very low",
            fr: "Très faible"
        }
    },
        {
            value: 2,
            label: {
            en: "Low",
            fr: "Faible"
        }
    },
        {
            value: 3,
            label: {
            en: "Satisfactory",
            fr: "Satisfaisant"
        }
    },
        {
            value: 4,
            label: {
            en: "Abundant",
            fr: "Abondant"
        }
    },
        {
            value: 5,
            label: {
            en: "Very abundant",
            fr: "Très abondant"
        }
    }
]

const REPORT = {
    types: [
        {
            value: 'beeomonitorée',
            label: {
                fr: 'Visite Beeomonitorée',
                en: 'Beeomonitored visit'
            },
            shortLabel: {
                fr: 'Beeomonitorée',
                en: 'Beeomonitored'
            }
        },
        {
            value: 'non-beeomonitorée',
            label: {
                fr: 'Visite Non-beeomonitorée',
                en: 'Non Beeomonitored visit'
            },
            shortLabel: {
                fr: 'Non-beeomonitorée',
                en: 'Non Beeomonitored'
            }
        },
        {
            value: 'dead',
            label: {
                fr: 'Colonie morte',
                en: 'Dead colony'
            },
            shortLabel: {
                fr: 'Morte',
                en: 'Dead'
            }
        },
        {
            value: 'canceled',
            label: {
                fr: 'Visite annulée',
                en: 'Cancelled Visit'
            },
            shortLabel: {
                fr: 'Annulée',
                en: 'Cancelled'
            }
        },
        {
            value: 'exceptional',
            label: {
                fr: 'Visite exceptionnelle',
                en: 'Exceptional visit'
            },
            shortLabel: {
                fr: 'Exceptio.',
                en: 'Exceptional'
            }
        }
    ],
    states: [
        {
            value: 'alive',
            label: 'Ruche opérationnel',
            shortLabel: 'Opérationnel'
        },
        {
            value: 'dead',
            label: 'Ruche morte',
            shortLabel: 'Morte'
        }
    ],
    fields: [
        {
            name: 'created',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'dead', 'canceled', 'exceptional'],
            optional: true,
            label: {
                fr: 'Date',
                nl: '',
                en: 'Date'
            },
            type: 'date'
        },
        {
            name: 'visit',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'select',
            multiple: false,
            label: {
                fr: 'Type de visite',
                nl: '',
                en: 'Kind of visit'
            },
            data: [
                /*{
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: ''
                    },
                    description: {
                        fr: '',
                        nl: '',
                        en: ''
                    }
                },*/
                {
                    value: 'winter',
                    label: {
                        fr: 'Visite d\'hivernage',
                        nl: '',
                        en: 'Wintering visit'
                    },
                    description: {
                        fr: 'Nous vérifions que les abeilles répondent à un stimulus durant leur hivernage.',
                        nl: '',
                        en: ''
                    },
                    email: 'hibernation period visit, to check whether the bees respond to a stimulus during hibernation.'
                },
                {
                    value: 'winter_outing',
                    label: {
                        fr: 'Visite de sortie d\'hivernage' ,
                        nl: '',
                        en: 'Wintering out visit'
                    },
                    description: {
                        fr: 'Nous vérifions l\'état de la colonies après l\'hiver et nous nous assurons que la ponte a redémarré ou va redémarrer rapidement.',
                        nl: '',
                        en: ''
                    },
                    email: 'end-of-hibernation visit, to check how the bees came through the winter and whether the queen has started or is about to start laying.'
                },
                {
                    value: 'routine',
                    label: {
                        fr: 'Visite de routine',
                        nl: '',
                        en: 'Day to day visit'
                    },
                    description: {
                        fr: 'Contrôle de l\'état sanitaire de la colonie, check des réserves de nourriture et de développement du couvain.',
                        nl: '',
                        en: ''
                    },
                    email: 'routine visit, to check the colony’s overall health, the food stores and to see how the brood is developing.',
                    emailBeeomonitored: 'routine Beeomonitored hive visit, to check the colony’s overall health, measure the honey and pollen stores in the hive and to see how the brood is developing. Data encoding.'
                },
                {
                    value: 'pre_winter',
                    label: {
                        fr: 'Visite de pré-hivernage',
                        nl: '',
                        en: 'Pre-wintering visit'
                    },
                    description: {
                        fr: 'Nous vérifions l\'état de la colonie avant l\'hiver et nous nous assurons que la nourriture est présente en quantité suffisante pour l\'hivernage.',
                        nl: '',
                        en: ''
                    },
                    email: 'pre-hibernation visit, to check the state of the hive before the onset of winter and to make sure that there is enough food in the hive to get the bees through the winter.'
                },
                {
                    value: 'control',
                    label: {
                        fr: 'Visite de contrôle de l\'essaimage et/ou division de la colonie',
                        nl: '',
                        en: 'Swarming control visit and/or division of the colony'
                    },
                    description: {
                        fr: '',
                        nl: '',
                        en: ''
                    },
                    email: 'visit to check swarming and/or colony division.'
                },
                {
                    value: 'exceptional',
                    label: {
                        fr: 'Visite exceptionnelle (suite à la visite précédente)',
                        nl: '',
                        en: 'Exceptional visit (following the previous visit)'
                    },
                    description: {
                        fr: '',
                        nl: '',
                        en: ''
                    },
                    email: 'exceptional visit (follow-up to an earlier visit).'
                }
            ]
        },
        {
            name: 'populatedLanes',
            applicableTypes: ['beeomonitorée'],
            type: 'number',
            label: {
                fr: 'Ruelles peuplées',
                nl: '',
                en: 'Bee spaces full of bees'
            },
            min: 0,
            max: 10,
            step: 0.5,
            more: false
        },
        {
            name: 'populatedLanesEval',
            applicableTypes: ['non-beeomonitorée'],
            type: 'stars',
            data: [...starsDefaultData],
            label: {
                fr: 'Ruelles peuplées',
                nl: '',
                en: 'Bee spaces full of bees'
            }
        },
        {
            name: 'frames',
            type: 'counter',
            label: {
                fr: 'Mesures sur cadres',
                nl: '',
                en: 'Frame measurements'
            },
            number: 10,
            min: 0,
            max: 8,
            step: 0.5,
            applicableTypes: ['beeomonitorée'],
            data: [
                {
                    key: 'brood',
                    label: {
                        fr: 'Couvain (unité: quart de face)',
                        nl: '',
                        en: 'Brood  (unit:1/4 side of frame)'
                    }
                },
                {
                    key: 'nectar',
                    label: {
                        fr: 'Nectar (unité: quart de face)',
                        nl: '',
                        en: 'Nectar  (unit:1/4 side of frame)'
                    }
                },
                {
                    key: 'pollen',
                    label: {
                        fr: 'Pollen (unité: quart de face)',
                        nl: '',
                        en: 'Pollen (unit:1/4 side of frame)'
                    }
                }
            ]
        },
        {
            name: 'honey',
            applicableTypes: ['non-beeomonitorée'],
            type: 'boolean',
            label: {
                fr: 'Nectar',
                nl: '',
                en: 'Nectar'
            },
            data: booleanData(),
            disabled: true
        },
        {
            name: 'honeyEval',
            applicableTypes: ['non-beeomonitorée'],
            type: 'stars',
            label: {
                fr: 'Nectar et/ou nourriture',
                nl: '',
                en: 'Nectar and/or bee feed'
            },
            data: [
                {
                        value: 0,
                        label: {
                        en: "Too low",
                        fr: "Trop faible"
                    }
                },
                {
                        value: 1,
                        label: {
                        en: "Very low",
                        fr: "Très faible"
                    }
                },
                    {
                        value: 2,
                        label: {
                        en: "Low",
                        fr: "Faible"
                    }
                },
                    {
                        value: 3,
                        label: {
                        en: "Satisfactory -",
                        fr: "Satisfaisant -"
                    }
                },
                    {
                        value: 4,
                        label: {
                        en: "Satisfactory +",
                        fr: "Satisfaisant +"
                    }
                },
                    {
                        value: 5,
                        label: {
                        en: "Abundant",
                        fr: "Abondant"
                    }
                }
            ]
        },
        {
            name: 'broodEval',
            applicableTypes: ['non-beeomonitorée'],
            type: 'stars',
            label: {
                fr: 'Couvain',
                nl: '',
                en: 'Brood'
            },
            data: [...starsDefaultData]
        },
        {
            name: 'pollen',
            applicableTypes: ['non-beeomonitorée'],
            type: 'boolean',
            label: {
                fr: 'Pollen',
                nl: '',
                en: 'Pollen'
            },
            data: booleanData(),
            disabled: true
        },
        {
            name: 'pollenEval',
            applicableTypes: ['non-beeomonitorée'],
            type: 'stars',
            label: {
                fr: 'Pollen',
                nl: '',
                en: 'Pollen'
            },
            data: [...starsDefaultData]
        },
        {
            name: 'queen',
            type: 'boolean',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            label: {
                fr: 'Reine vue',
                nl: '',
                en: 'Queen seen'
            },
            data: booleanData()
        },
        {
            name: 'eggs',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'boolean',
            label: {
                fr: 'Oeuf',
                nl: '',
                en: 'Eggs'
            },
            data: booleanData()
        },
        /*{
            name: 'eggsEval',
            applicableTypes: ['non-beeomonitorée'],
            type: 'stars',
            label: {
                fr: 'Oeuf',
                nl: '',
                en: 'Eggs'
            },
            data: starsDefaultData
        },*/
        {
            name: 'pollenTrap',
            disabled: true,
            applicableTypes: ['beeomonitorée'],
            type: 'boolean',
            label: {
                fr: 'Trappe à pollen',
                nl: '',
                en: 'Pollen Trap'
            },
            data: booleanData()
        },
        {
            name: 'sample',
            applicableTypes: ['beeomonitorée', 'exceptional'],
            type: 'select',
            defaultValue: 'none',
            label: {
                fr: 'Prélèvement',
                nl: '',
                en: 'Sample taken inside the hive'
            },
            data: [
                {
                    value: 'pollenTrap',
                    label: {
                        fr: 'Trappe à Pollen',
                        nl: '',
                        en: 'Pollen trap'
                    }
                },
                {
                    value: 'none',
                    label: {
                        fr: 'Pas de prise d’échantillon',
                        nl: '',
                        en: 'No sampling'
                    }
                },
                {
                    value: 'not_available',
                    label: {
                        fr: 'Pas d’échantillon disponible',
                        nl: '',
                        en: 'No sample available'
                    }
                },
                {
                    value: 'insideHive',
                    label: {
                        fr: 'Intérieur de ruche',
                        nl: '',
                        en: 'Inside the hive'
                    }
                }
            ]
        },
        {
            name: 'sample_bak',
            disabled: true,
            applicableTypes: ['beeomonitorée'],
            type: 'boolean',
            label: {
                fr: 'Prélèvement',
                nl: '',
                en: 'Sample'
            },
            defaultValue: false,
            data: booleanData()
        },
        {
            name: 'maladies',
            type: 'booleans',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            optional: true,
            defaultValue: false,
            label: {
                fr: 'Maladies',
                nl: '',
                en: 'Diseases'
            },
            data: [
                {
                    value: '1',
                    label: {
                        fr: 'Du couvain en mosaïque avec des opercules percés',
                        nl: '',
                        en: 'Mosaic brood and capping with small holes'
                    }
                },
                {
                    value: '2',
                    label: {
                        fr: 'Des cellules royales mélanisées',
                        nl: '',
                        en: 'Dark queen cells'
                    }
                },
                {
                    value: '3',
                    label: {
                        fr: 'Des abeilles aux ailes déformées',
                        nl: '',
                        en: 'Bees with deformed wings'
                    }
                },
                {
                    value: '4',
                    label: {
                        fr: 'Des varroas',
                        nl: '',
                        en: 'Varroa mite'
                    }
                },
                {
                    value: '5',
                    label: {
                        fr: 'Des abeilles à l’abdomen noir, gonflé et glabre',
                        nl: '',
                        en: 'Bees with a black abdomen'
                    }
                },
                {
                    value: '6',
                    label: {
                        fr: 'Des déjections en quantité importante à l’intérieur de la colonie',
                        nl: '',
                        en: 'Large droppings inside the colony'
                    }
                },
                {
                    value: '7',
                    label: {
                        fr: 'Du couvain plâtré',
                        nl: '',
                        en: 'Chalkbrood'
                    }
                },
                {
                    value: '8',
                    label: {
                        fr: 'De la fausse-teigne (petite ou grande)',
                        nl: '',
                        en: 'Wax moth (small or big)'
                    }
                },
                {
                    value: '9',
                    label: {
                        fr: 'De l’aspergillose',
                        nl: '',
                        en: 'Aspergillosis'
                    }
                },
                { 
                    value: '10',
                    label: {
                        fr: 'Du couvain visqueux et une odeur d’ammoniaque',
                        nl: '',
                        en: 'Sticky brood and a smell of ammonia'
                    }
                },
                {
                    value: '11',
                    label: {
                        fr: 'Du couvain en forme d’écaille difficilement détachable des cellules',
                        nl: '',
                        en: 'Brood in the form of scales difficult to detach from cells'
                    }
                },
                {
                    value: '12',
                    label: {
                        fr: 'Du couvain en forme d’écaille facilement détachable des cellules',
                        nl: '',
                        en: 'Brood in the form of scales easy to detach from cells'
                    }
                }
            ]
        },
        {
            name: 'comment',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'dead', 'canceled', 'exceptional'],
            optional: true,
            defaultValue: '',
            label: {
                fr: 'Commentaire',
                nl: '',
                en: 'Comment'
            },
            type: 'text'
        },
        {
            name: 'toDo',
            type: 'select',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            multiple: true,
            optional: true,
            defaultValue: 'none',
            label: {
                fr: 'A faire lors de la prochaine visite',
                nl: '',
                en: 'To do during the next visit'
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'feed',
                    label: {
                        fr: 'Nourrir',
                        nl: '',
                        en: 'Feed'
                    }
                },
                {
                    value: 'divide',
                    label: {
                        fr: 'Diviser',
                        nl: '',
                        en: 'Divide'
                    }
                },
                {
                    value: 'replace',
                    label: {
                        fr: 'Remplacer',
                        nl: '',
                        en: 'Replace'
                    }
                },
                {
                    value: 'cut',
                    label: {
                        fr: 'Taille / jardinage',
                        nl: '',
                        en: 'Pruning / gardening'
                    }
                },
                {
                    value: 'replace_materials',
                    label: {
                        fr: 'Remplacement matériel manquant',
                        nl: '',
                        en: 'Replacement of missing equipment'
                    }
                },
                {
                    value: 'nothing',
                    label: {
                        fr: 'Rien de spécial',
                        nl: '',
                        en: 'Nothing special'
                    }
                },
                {
                    value: 'replace_frames',
                    label: {
                        fr: 'Remplacement de cadres',
                        nl: '',
                        en: 'Replacement of frames'
                    }
                },
                {
                    value: 'reform',
                    label: {
                        fr: 'Ruche à réformer',
                        nl: '',
                        en: 'Hive to be reformed'
                    }
                }
            ]
        },
        {
            name: 'rise',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'number',
            optional: true,
            defaultValue: 0,
            label: {
                fr: 'Poids de la hausse (kg)',
                nl: '',
                en: 'Weight of the honey storage (kg)'
            },
            min: 0,
            max: 99,
            step: 1,
            more: true
        },
        {
            name: 'missingMaterials',
            type: 'select',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            multiple: true,
            optional: true,
            defaultValue: 'none',
            label: {
                fr: 'Matériel manquant',
                nl: '',
                en: 'Missing equipment'
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'bodies_frame',
                    label: {
                        fr: 'Cadre de corps',
                        nl: '',
                        en: 'Body frame'
                    }
                },
                {
                    value: 'entrance',
                    label: {
                        fr: 'Entrée',
                        nl: '',
                        en: 'Entrance'
                    }
                },
                {
                    value: 'rise',
                    label: {
                        fr: 'Hausse',
                        nl: '',
                        en: 'Honey storage'
                    }
                },
                {
                    value: 'rise_frame',
                    label: {
                        fr: 'Cadre de hausse',
                        nl: '',
                        en: 'Honey storage frame'
                    }
                },
                {
                    value: 'roof',
                    label: {
                        fr: 'Toit',
                        nl: '',
                        en: 'Roof'
                    }
                },
                {
                    value: 'insulating',
                    label: {
                        fr: 'Isolant',
                        nl: '',
                        en: 'Insulation'
                    }
                },
                {
                    value: 'foot',
                    label: {
                        fr: 'Pied',
                        nl: '',
                        en: 'Foot'
                    }
                },
                {
                    value: 'dibbon_plate',
                    label: {
                        fr: 'Plaque Dibond',
                        nl: '',
                        en: 'Dibond plate'
                    }
                },
                {
                    value: 'strap',
                    label: {
                        fr: 'Sangle',
                        nl: '',
                        en: 'Strap'
                    }
                },
                {
                    value: 'frame_plate',
                    label: {
                        fr: 'Planche couvre cadre',
                        nl: '',
                        en: 'Frame covers'
                    }
                },
                {
                    value: 'ground',
                    label: {
                        fr: 'Sol',
                        nl: '',
                        en: 'Ground'
                    }
                },
                {
                    value: 'isolated_frame',
                    label: {
                        fr: 'Cadre isolé',
                        nl: '',
                        en: 'Isolated frame'
                    }
                },
                {
                    value: 'cover_plate',
                    label: {
                        fr: 'Planchette couvre cadre',
                        nl: '',
                        en: 'Frame covers'
                    }
                },
                {
                    value: 'queen_grid',
                    label: {
                        fr: 'Grille a reine',
                        nl: '',
                        en: 'Queen excluder'
                    }
                },
                {
                    value: 'feeder',
                    label: {
                        fr: 'Nourrisseur',
                        nl: '',
                        en: 'Feeder'
                    }
                },
                {
                    value: 'pollenTrap',
                    label: {
                        fr: 'Trappe à pollen',
                        nl: '',
                        en: 'Pollen trap'
                    }
                }
            ]
        },
        {
            name: 'treatment',
            type: 'select',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'exceptional'],
            multiple: false,
            optional: true,
            //defaultValue: 'none',
            label: {
                fr: 'Traitement',
                nl: '',
                en: 'Treatment'
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'adding',
                    label: {
                        fr: 'Ajout',
                        nl: '',
                        en: 'Adding'
                    },
                },
                {
                    value: 'withdrawal',
                    label: {
                        fr: 'Retrait',
                        nl: '',
                        en: 'Removing'
                    }
                },
            ]
        },
        /*{
            name: 'food',
            type: 'select',
            applicableTypes: ['non-beeomonitorée'],
            multiple: false,
            optional: true,
            //defaultValue: 'none',
            label: {
                fr: 'Nourriture',
                nl: '',
                en: 'Food'
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'adding',
                    label: {
                        fr: 'Ajout',
                        nl: '',
                        en: 'Adding'
                    },
                },
                {
                    value: 'withdrawal',
                    label: {
                        fr: 'Retrait',
                        nl: '',
                        en: 'Removing'
                    }
                },
            ]
        },*/
        {
            name: 'treatment_bak2',
            disabled: true,
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'number',
            label: {
                fr: 'Traitement',
                nl: '',
                en: ''
            },
            min: 0,
            max: 10,
            step: 1,
            more: false,
            defaultValue: 0,
            optional: true
        },
        {
            name: 'treatment_bak',
            disabled: true,
            type: 'select',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            multiple: false,
            optional: true,
            defaultValue: 'none',
            label: {
                fr: 'Traitement',
                nl: '',
                en: ''
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    },
                },
                {
                    value: 'next_time',
                    label: {
                        fr: 'A placer prochaine fois',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'added_now',
                    label: {
                        fr: 'Placé lors de cette visite',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'retired_now',
                    label: {
                        fr: 'Retiré lors de cette visite',
                        nl: '',
                        en: ''
                    }
                }
            ]
        },
        {
            name: 'feeding',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'exceptional'],
            type: 'select',
            multiple: false,
            //defaultValue: 'none',
            optional: true,
            label: {
                fr: 'Nourrissement',
                nl: '',
                en: 'Feeding'
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'syrup',
                    label: {
                        fr: 'Sirop',
                        nl: '',
                        en: 'Syrup'
                    },
                },
                {
                    value: 'solidSugar',
                    label: {
                        fr: 'Sucre solide',
                        nl: '',
                        en: 'Solid sugar'
                    }
                },
            ]
        },
        {
            name: 'feeding_bak2',
            disabled: true,
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'number',
            label: {
                fr: 'Nourrissement',
                nl: '',
                en: ''
            },
            min: 0,
            max: 10,
            step: 1,
            optional: true,
            defaultValue: 0,
            more: false
        },
        {
            name: 'feeding_bak',
            disabled: true,
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'select',
            multiple: false,
            defaultValue: 'none',
            optional: true,
            label: {
                fr: 'Nourrissement',
                nl: '',
                en: ''
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'not_necessary',
                    label: {
                        fr: 'Pas nécessaire - réserves suffisantes dans la ruche',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'half_can',
                    label: {
                        fr: 'Fait - un demi bidon',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'full_can',
                    label: {
                        fr: 'Fait - un bidon',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'sugar_bread',
                    label: {
                        fr: 'Fait - un pain de sucre solide',
                        nl: '',
                        en: ''
                    }
                }
            ]
        },
        {
            name: 'royalCells',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'boolean',
            optional: true,
            defaultValue: false,
            label: {
                fr: 'Cellules Royales',
                nl: '',
                en: 'Queen cells'
            },
            data: booleanData()
        },
        {
            name: 'royalCells_bak',
            disabled: true,
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'number',
            optional: true,
            defaultValue: 0,
            label: {
                fr: 'Cellules Royales',
                nl: '',
                en: ''
            },
            min: 0,
            max: 11,
            step: 1,
            more: true
        },
        {
            name: 'hiveState',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'boolean',
            optional: true,
            label: {
                fr: 'Ruche en bon état',
                nl: '',
                en: 'Beehive in good condition'
            },
            data: booleanData()
        },
        {
            name: 'division',
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'boolean',
            optional: true,
            label: {
                fr: 'Division',
                nl: '',
                en: 'Division'
            },
            data: booleanData()
        },
        {
            name: 'state',
            disabled: true,
            applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
            type: 'select',
            optional: true,
            defaultValue: 'good',
            multiple: false,
            label: {
                fr: 'Etat général',
                nl: '',
                en: ''
            },
            data: [
                {
                    value: 'none',
                    label: {
                        fr: 'N/A',
                        nl: '',
                        en: 'N/A'
                    }
                },
                {
                    value: 'new',
                    label: {
                        fr: 'Nouvelle ruche',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'perfect',
                    label: {
                        fr: 'Parfait',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'good',
                    label: {
                        fr: 'Bon',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'to_monitor',
                    label: {
                        fr: 'A surveiller',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'dead',
                    label: {
                        fr: 'Morte',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'just_spread',
                    label: {
                        fr: 'Vient d\'essaimer',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'royal_cells',
                    label: {
                        fr: 'Présence de Cellules Royales',
                        nl: '',
                        en: ''
                    }
                },
                {
                    value: 'just_split',
                    label: {
                        fr: 'Vient d\'etre divisée',
                        nl: '',
                        en: ''
                    }
                }
            ]
        }
    ]
}

export default Object.freeze(REPORT)


// WEBPACK FOOTER //
// ./src/constant/REPORT.js